export default "__VITE_ASSET__DxxEJsn3__"